// extracted by mini-css-extract-plugin
export default {"JobDescriptionCard":"JobDescriptionCard_JobDescriptionCard__UB4kL","title":"JobDescriptionCard_title__c3yrv","description":"JobDescriptionCard_description__Md3CY"};